export default __webpack_public_path__ + "b7541889ae6be17ca4c95bd855027514.svg";